var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHardwareGoose = function SvgHardwareGoose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 72.6787,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 63.75,
    width: 7.14286,
    height: 14.6429,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 69.1064,
    width: 57.1429,
    height: 8.92857,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2144,
    y: 63.75,
    width: 32.1429,
    height: 8.92857,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 60.1787,
    width: 42.8571,
    height: 9.28571,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1426 51.25H36.0711V54.8218H28.9283V67.3218H28.9282V58.3929H19.9996V67.3218H14.6426V78.036H21.7855V79.8216H60.1784V78.036H71.7854V72.6788H75.3569V61.9645H69.9997V54.8218H52.1426V51.25Z",
    fill: "#F7CE58"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 56.6064,
    width: 17.8571,
    height: 9.28571,
    fill: "#F7CE58"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 17.3213,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0713,
    y: 49.4639,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 53.0361,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 65.5361,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 63.75,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 76.25,
    width: 7.14286,
    height: 1.78571,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 83.3926,
    width: 46.4286,
    height: 1.78571,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 56.6064,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 28.0361,
    width: 8.92857,
    height: 1.78571,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 35.1787,
    width: 12.5,
    height: 1.78571,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 20,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2856,
    y: 51.249,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 78.0361,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8569,
    y: 67.3213,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1431,
    y: 54.8213,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 25.3564,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 24.4639,
    width: 1.78571,
    height: 28.5714,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 36.9639,
    width: 1.78571,
    height: 21.4286,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 56.6064,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 61.9639,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 67.3213,
    width: 32.1429,
    height: 1.78571,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 58.3926,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 60.1787,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 72.6787,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3569,
    y: 61.9639,
    width: 1.78571,
    height: 10.7143,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 58.3926,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 72.6787,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7144,
    y: 29.8213,
    width: 1.78571,
    height: 7.14286,
    fill: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 23.5713,
    width: 16.0714,
    height: 31.25,
    fill: "#514E4E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 20,
    width: 14.2857,
    height: 10.7143,
    fill: "#302E2E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 29.8213,
    width: 14.2857,
    height: 7.14286,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 19.1064,
    width: 14.2857,
    height: 10.7143,
    fill: "#514E4E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 29.8213,
    width: 14.2857,
    height: 5.35714,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 25.3564,
    width: 10.7143,
    height: 7.14286,
    fill: "#514E4E"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 24.4639,
    width: 3.57143,
    height: 5.35714,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 24.4639,
    width: 1.78571,
    height: 1.78571,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 54.8213,
    width: 14.2857,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 69.1064,
    width: 8.92857,
    height: 3.57143,
    fill: "#FFFEFD"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 78.0361,
    width: 8.92857,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 74.4639,
    width: 1.78571,
    height: 3.57143,
    fill: "#FFFEFD"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 78.0361,
    width: 46.4286,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 65.5361,
    width: 30.3571,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 78.0361,
    width: 33.9286,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 81.6064,
    width: 46.4286,
    height: 1.78571,
    fill: "#BABABA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 79.8213,
    width: 46.4286,
    height: 1.78571,
    fill: "#EAEAEA"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 76.25,
    width: 7.14286,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 67.3213,
    width: 7.14286,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0713,
    y: 72.6787,
    width: 1.78571,
    height: 3.57143,
    fill: "#B1923B"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 61.9639,
    width: 1.78571,
    height: 3.57143,
    fill: "#B1923B"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 58.3926,
    width: 1.78571,
    height: 3.57143,
    fill: "#B1923B"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 58.3926,
    width: 3.57143,
    height: 5.35714,
    fill: "#B1923B"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 63.75,
    width: 1.78571,
    height: 3.57143,
    fill: "#B1923B"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 53.0361,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 70.8936,
    width: 5.35714,
    height: 5.35714,
    fill: "#B1923B"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 70.8936,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 74.4639,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 20,
    width: 1.78571,
    height: 4.46429,
    fill: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 79.8213,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 72.6787,
    width: 7.14286,
    height: 5.35714,
    fill: "#FFFEFD"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 78.0361,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 78.0361,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 69.1064,
    width: 3.57143,
    height: 1.78571,
    transform: "rotate(90 68.2144 69.1064)",
    fill: "#B1923B"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 72.6787,
    width: 3.57143,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 58.3926,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 61.9639,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4287,
    y: 63.75,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 17.3213,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 15.5361,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 17.3213,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 20.8926,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 19.1064,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 17.3213,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 19.1064,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 17.3213,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 10.1787,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 10.1787,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 6.60645,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 6.60645,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 4.82129,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 4.82129,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 8.39258,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 6.60645,
    width: 3.57143,
    height: 3.57143,
    fill: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 8.39258,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 11.9639,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 11.9639,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 11.9639,
    width: 1.78571,
    height: 5.35714,
    fill: "#B1923B"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 10.1787,
    width: 14.2857,
    height: 8.92857,
    fill: "#F7CE58"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 17.3213,
    width: 3.57143,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 17.3213,
    width: 3.57143,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 10.1787,
    width: 1.78571,
    height: 5.35714,
    fill: "#B1923B"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 10.1787,
    width: 1.78571,
    height: 5.35714,
    fill: "#B1923B"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 11.9639,
    width: 1.78571,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 6.60645,
    width: 1.78571,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 6.60645,
    width: 1.78571,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 60.1782,
    y: 10.1787,
    width: 1.78571,
    height: 7.14286,
    fill: "#B1923B"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 19.1064,
    width: 14.2857,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 72.6787,
    width: 45.1786,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4287,
    y: 72.6787,
    width: 3.03571,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 74.4639,
    width: 37.1429,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8569,
    y: 70.8936,
    width: 45.1786,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4644,
    y: 70.8936,
    width: 3.57143,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 69.1064,
    width: 45.1786,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 67.3213,
    width: 9.46429,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 58.0356,
    y: 67.3213,
    width: 1.78571,
    height: 3.57143,
    fill: "#C47937"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 58.0356,
    y: 67.3213,
    width: 1.78571,
    height: 3.57143,
    fill: "#F7CE58"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 61.9639,
    width: 9.46429,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8213,
    y: 61.9639,
    width: 1.78571,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 54.8213,
    width: 9.46429,
    height: 7.14286,
    fill: "#F7CE58"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 53.0361,
    width: 9.46429,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 61.6069,
    y: 53.0361,
    width: 1.78571,
    height: 8.92857,
    fill: "#F7CE58"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 51.249,
    width: 9.46429,
    height: 1.78571,
    fill: "#F7CE58"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 67.3213,
    width: 3.57143,
    height: 1.78571,
    fill: "#F7CE58"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHardwareGoose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hardwareGoose.6b8f3a0b.svg";
export { ForwardRef as ReactComponent };